import {
    INSTRUCTOR,
    OUTLINE,
    CRUD_2,
    CRUD_1,
    UPDATE_COURSE_DATA,
    FAQS,
    TOOLS,
    NEXTUP,
    DRAG,
    CHANGE_FLAG,
    EXTERNAL_COURSE,
    ADD_START_DATE,
    SELECT_DATE_TYPE,
    EVENT,
    TOOLSLIST,
    OVERVIEW,
    FOURCEUPD,
    COURSEASSIGNMENT
} from '../constants';
import nextId from 'react-id-generator';

const initialState = {
    Cohort: false,
    individual_course_fees: 0,
    update_outline: false,
    deleted_post_id: [],
    instructor: [{ type: 'instructor' }],
    external_course: [],
    outline: [{ sub_topic: [{ RISE_topic_id: nextId() }] , program_name:"", program_start_date:"", }],
    FAQ: [{ FAQ_id: nextId() + '1', question: '', answer: '' }],
    assignments: [{ assignment_id: nextId() + '1', title: '', raw: '' }],
    event: [{ Event_id: nextId() + '1',question: "", answer: "" , eventName: "", Description: "" ,Location:"",Meeting:"",virtual_event:"" , multiday_event:"" , allday_event:"" ,is_location_required:"" ,event_date:"", event_end_date:"", event_start_time:"",event_end_time:"", event_pdf_link:"",upload_video_link:"",event_video_link:"",program_id:[], event_time_zone:""}],
    Tools: [],
    Tools:[{Tools_ID: nextId(), title: "",link_display_text: "",link: "",instructions: "",sub_topic: []}],
    next_up_block: [
        {
            welcome_msg: '',
            next_up: [{ nextCourse_id: nextId() + '1', title: '', instruction: '' }]
        }
    ],  
    tags: [],
    start_date: [],
    start_date_type:'',
    overview:'',
    title:"",
    show_outline_button:false
};

export const courseCrud = (formData = initialState, { type, payload }) => {
    switch (type) {
        case UPDATE_COURSE_DATA: {
            const { payload: apiData, CMS_TYPE } = payload;
            console.log("initialState",initialState)
            if (CMS_TYPE === 'pre-college') {
                return {
                    next_up_block: initialState.next_up_block,
                    start_date: initialState?.start_date,
                    ...apiData,
                    external_course: apiData.hasOwnProperty('external_course')
                        ? apiData?.external_course
                        : [],
                };
            }else if(CMS_TYPE === 'dl-program'){
                return {
                    next_up_block: initialState.next_up_block,
                    start_date: initialState?.start_date,
                    overview:"",
                    Tools:apiData.Tools,
                    event:apiData.event,
                    ...apiData,
                    external_course: apiData.hasOwnProperty('external_course')
                        ? apiData?.external_course
                        : []
                };
            }else {
                return {
                    course_type: 'Skill up',
                    ...apiData,
                    external_course: apiData.hasOwnProperty('external_course')
                        ? apiData?.external_course
                        : []
                };
            }
        }
        case INSTRUCTOR: {
            const { type, url } = payload;
            switch (typeof type === 'object' ? type.type : type) {
                case 'add': {
                    formData = {
                        ...formData,
                        instructor: [...formData.instructor, { type: 'instructor' }]
                    };
                    break;
                }
                case 'file': {
                    formData = {
                        ...formData,
                        instructor: [
                            ...formData.instructor.slice(0, +type.id),
                            {
                                ...formData.instructor[+type.id],
                                [type.name]: url
                            },
                            ...formData.instructor.slice(+type.id + 1)
                        ]
                    };
                    break;
                }
                case 'change': {
                    if (type.target.type === 'radio') {
                        formData = {
                            ...formData,
                            instructor: [
                                ...formData.instructor.slice(0, +type.target.name),
                                {
                                    ...formData.instructor[+type.target.name],
                                    [type.target.id]: type.target.value
                                },
                                ...formData.instructor.slice(+type.target.name + 1)
                            ]
                        };
                    } else {
                        formData = {
                            ...formData,
                            instructor: [
                                ...formData.instructor.slice(0, +type.target.id),
                                {
                                    ...formData.instructor[+type.target.id],
                                    [type.target.name]: type.target.value
                                },
                                ...formData.instructor.slice(+type.target.id + 1)
                            ]
                        };
                    }
                    break;
                }
                default: {
                    let temp = { ...formData };
                    temp.instructor.splice(type, 1);
                    formData = { ...temp };
                    break;
                }
            }
            return formData;
        }
        case EXTERNAL_COURSE: {
            const { type, url } = payload;
            switch (typeof type === 'object' ? type.type : type) {
                case 'add': {
                    formData = {
                        ...formData,
                        external_course: [
                            ...formData.external_course,
                            {
                                course_title: '',
                                cover_image: '',
                                faculty_school_name: '',
                                link: ''
                            }
                        ]
                    };
                    break;
                }
                case 'file': {
                    formData = {
                        ...formData,
                        external_course: [
                            ...formData.external_course.slice(0, +type.id),
                            {
                                ...formData.external_course[+type.id],
                                [type.name]: url
                            },
                            ...formData.external_course.slice(+type.id + 1)
                        ]
                    };
                    break;
                }
                case 'change': {
                    if (type.target.type === 'radio') {
                        formData = {
                            ...formData,
                            external_course: [
                                ...formData.external_course.slice(0, +type.target.name),
                                {
                                    ...formData.external_course[+type.target.name],
                                    [type.target.id]: type.target.value
                                },
                                ...formData.external_course.slice(+type.target.name + 1)
                            ]
                        };
                    } else {
                        formData = {
                            ...formData,
                            external_course: [
                                ...formData.external_course.slice(0, +type.target.id),
                                {
                                    ...formData.external_course[+type.target.id],
                                    [type.target.name]: type.target.value
                                },
                                ...formData.external_course.slice(+type.target.id + 1)
                            ]
                        };
                    }
                    break;
                }
                default: {
                    let temp = { ...formData };
                    temp.external_course.splice(type, 1);
                    formData = { ...temp };
                    break;
                }
            }
            return formData;
        }
        case OUTLINE: {
            const { type, progress, outline, url } = payload;
            switch (typeof type === 'object' ? type.type : type) {
                case 'zip': {
                    formData = {
                        ...formData,
                        update_outline: true,
                        outline: [
                            ...formData.outline.slice(0, +type.id),
                            {
                                ...formData.outline[+type.id],
                                RISE_topic_outline: outline,
                                RISE_topic_path: url
                            },
                            ...formData.outline.slice(+type.id + 1)
                        ]
                    };
                    break;
                }
                case 'add': {
                    let flag = true;
                    Object.entries(progress).length > 0 &&
                        Object.entries(progress).map((data) => {
                            if (data[1]) {
                                flag = false;
                            }
                        });
                    if (flag) {
                        formData = {
                            ...formData,
                            outline: [
                                ...formData.outline,
                                {
                                    RISE_topic_id: nextId() + '1',
                                    RISE_topic_name: '',
                                    RISE_topic_outline: [],
                                    RISE_topic_path: '',
                                    sub_topic: []
                                }
                            ]
                        };
                    }
                    break;
                }
                case 'change': {
                    if (type.target.name === 'RISE_topic_name')
                        formData = {
                            ...formData,
                            update_outline: true,
                            outline: [
                                ...formData.outline.slice(0, +type.target.id),
                                {
                                    ...formData.outline[+type.target.id],
                                    [type.target.name]: type.target.value.trimLeft()
                                },
                                ...formData.outline.slice(+type.target.id + 1)
                            ]
                        };
                        else if(type.target.name === 'show_outline_button'){
                            formData = {
                                ...formData,
                                [type.target.name]: type.target.checked
                            }
                        }
                    else
                        formData = {
                            ...formData,
                            outline: [
                                ...formData.outline.slice(0, +type.target.id),
                                {
                                    ...formData.outline[+type.target.id],
                                    [type.target.name]: type.target.value.trimLeft()
                                },
                                ...formData.outline.slice(+type.target.id + 1)
                            ]
                        };
                    break;
                } 
                case 'addSubTopic': {
                    formData = {
                        ...formData,
                        outline: [
                            ...formData.outline.slice(0, type.id),
                            {
                                ...formData.outline[type.id],
                                sub_topic: [
                                    ...formData.outline[type.id]['sub_topic'],
                                    { activity: [] }
                                ]
                            },
                            ...formData.outline.slice(type.id + 1)
                        ]
                    };
                    break;
                }
                case 'removeSubTopic': {
                    let temp = { ...formData };
                    if (type.post_id)
                        temp.deleted_post_id = [...temp.deleted_post_id, type.post_id];
                    temp.outline[+type.id].sub_topic.splice(+type.sub_id, 1);
                    formData = { ...temp };
                    break;
                }
                case 'removeLink': {
                    let temp = { ...formData };
                    temp.outline[+type.id].sub_topic[+type.sub_id]['activity'] = [];
                    // temp.outline[+type.id].sub_topic[+type.sub_id]['link'] = null;
                    formData = { ...temp };
                    break;
                }
                default: {
                    let flag = true;
                    Object.entries(progress).length > 0 &&
                        Object.entries(progress).map((data) => {
                            if (data[1]) {
                                flag = false;
                            }
                        });
                    if (flag) {
                        let temp = { ...formData };
                        temp.outline.splice(+type, 1);
                        formData = { ...temp };
                    }
                }
            }
            return formData;
        }
        case FAQS: {
            const { type } = payload;
            switch (typeof type === 'object' ? type.type : type) {
                case 'add': {
                    formData = {
                        ...formData,
                        FAQ: [
                            ...formData.FAQ,
                            { FAQ_id: nextId() + '1', question: '', answer: '' }
                        ]
                    };
                    break;
                }
                case 'change': {
                    formData = {
                        ...formData,
                        FAQ: [
                            ...formData.FAQ.slice(0, +type.target.id),
                            {
                                ...formData.FAQ[+type.target.id],
                                [type.target.name]: type.target.value
                            },
                            ...formData.FAQ.slice(+type.target.id + 1)
                        ]
                    };
                    break;
                }
                default: {
                    let temp = { ...formData };
                    temp.FAQ.splice(type, 1);
                    formData = { ...temp };
                    break;
                }
            }
            return formData;
        }
        case COURSEASSIGNMENT: {
            const { type } = payload;
            console.log("call fun")
            switch (typeof type === 'object' ? type.type : type) {
                case 'add': {
                    console.log("call  1")
                    formData = {
                        ...formData,
                        assignments: [
                            ...formData.assignments,
                            { assignment_id: nextId() + '1', title: '', raw : '' }
                        ]
                    };
                    break;
                }
                case 'change': {
                    formData = {
                        ...formData,
                        assignments: [
                            ...formData.assignments.slice(0, +type.target.id),
                            {
                                ...formData.assignments[+type.target.id],
                                [type.target.name]: type.target.value?.trimLeft()
                            },
                            ...formData.assignments.slice(+type.target.id + 1)
                        ]
                    };
                    break;
                }
                default: {
                    console.log("call  2")
                    let temp = { ...formData };
                    temp.assignments.splice(type, 1);
                    formData = { ...temp };
                    break;
                }
            }
            return formData;
        }
        case EVENT: {
            const { type } = payload;
            
            switch (typeof type === 'object' ? type.type || type.target.type : type) {
                case 'add': {
                    formData = {
                        ...formData,
                        event: [
                            ...formData.event,
                            { Event_id: nextId() + '1',question: "", answer: "" , eventName: "", Description: "" ,Location:"",Meeting:"" }
                        ]
                    };
                    break;
                }
                case 'change': {
                    
                    const targetName = type.target.name;
                    console.log("targetName==",targetName)
                    const targetValue = Array?.isArray(type?.target?.value) ?  type.target.value : type.target.name === "event_time_zone" ? type.target.value.id :   type.target.value?.trimLeft()
                    const wordCount = Array?.isArray(type?.target?.value) ? targetValue : targetValue?.trim()?.split(/\s+/).length
                    formData = {
                        ...formData,
                        event: formData.event.map((event, index) =>
                            index === +type.target.id
                                ? { ...event, [targetName]: targetName === "event_description" && wordCount > 500 ? targetValue
                                .trim()
                                .split(/\s+/)
                                .slice(0, 500)
                                .join(' ') : targetValue }
                                : event
                        )
                    };
                    break;
                }
                case 'deleteevent': {
                    const { type } = payload;
                    const targetName = type.target.name;
                   
                    formData = {
                        ...formData,
                        event: formData.event.map((event, index) =>
                            index ===  type.target.id
                                ? { ...event, [targetName]: '' }
                                : event
                        )
                    };
                    break;
                }
                case 'pdf':{
                    const { id, url, type } = payload; 
                    const keyname = type?.filetype === ".pdf" ? 'event_pdf_link': 'upload_video_link';
                    formData = {
                        ...formData,
                        event: formData.event.map((event, index) =>
                            index === type.id
                            ? { ...event, [keyname]: url }
                                : event
                        )
                    }; 
                    break;
                }
                case 'checkbox': {
                    const targetName = type.target.name;
                    const targetChecked = type.target.checked;
                    formData = {
                        ...formData,
                        event: formData.event.map((event, index) =>
                            index === +type.target.id
                                ? { ...event, [targetName]: targetChecked }
                                : event
                        )
                    };
                    break;
                }
                default: {
                    let temp = { ...formData };
                    temp.event.splice(type, 1);
                    formData = { ...temp };
                    break;
                }
            }
            return formData;
        }
        case TOOLSLIST: {
            const { type } = payload;
          
            switch (typeof type === "object" ? type.type : type) {
              case "add": {
                formData = {
                  ...formData,
                  Tools: [
                    ...formData.Tools,
                    {
                      Tools_ID: nextId() + "1",
                      title: "",
                      link_display_text: "",
                      link: "",
                      instructions: "",
                      sub_topic: [],
                    },
                  ],
                };
                break;
              }
              case "change": {
                const targetName = type.target.name;
                const targetValue = type.target.value;
                
                console.log("type.target.id", type.target.id, type.target);
                formData = {
                  ...formData,
                  Tools: formData.Tools.map((event, index) =>
                    index === +type.target.id
                      ? { ...event, [targetName]: targetValue }
                      : event
                  ),
                };
                break;
              }
              case "link": {
                const { link, type } = payload;

                formData = {
                  ...formData,
                  Tools: formData.Tools.map((event, index) =>
                    event.Tools_ID === type.id
                      ? {
                          ...event,
                          sub_topic: event.sub_topic.some(
                            (sub) => sub.type === type.target.name
                          )
                            ? event.sub_topic.filter(
                                (sub) => sub.type !== type.target.name
                              )
                            : [
                                ...event.sub_topic,
                                { link: link, type: type.target.name },
                              ],
                        }
                      : event
                  ),
                };

                break;
              }
              case "link_change": {
                const { type , value} = payload;
    
                formData = {
                  ...formData,
                  Tools: formData.Tools.map((event, index) =>
                  event.Tools_ID === type.id
                  ? {
                      ...event,
                      sub_topic: event.sub_topic.map((sub) =>
                      sub.type === type.name
                          ? { ...sub, link: type.value.target.value }
                          : sub
                  ),
                  }
                  : event
                  ),
                };

                break;
              }
              case 'delete':{
                const { link, type } = payload;
                formData = {
                    ...formData,
                    Tools: formData.Tools.map((event, index) =>
                      event.Tools_ID === type.id
                        ? {
                            ...event,
                            sub_topic: [],
                          }
                        : event
                    ),
                  };
  
                break;
              }
              default: {
                let temp = { ...formData };
                temp.Tools.splice(type, 1);
                formData = { ...temp };
                break;
              }
            }
            return formData;
        }
        case TOOLS: {
            const { type } = payload;
            switch (typeof type === 'object' ? type.type : type) {
                case 'add': {
                    if (formData?.hasOwnProperty('Tools')) {
                        formData = {
                            ...formData,
                            Tools: [
                                ...formData.Tools,
                                {
                                    TOOL_id: nextId() + '1',
                                    title: '',
                                    link_display_text: '',
                                    link: '',
                                    instructions: ''
                                }
                            ]
                        };
                    } else {
                        formData = {
                            ...formData,
                            Tools: [
                                {
                                    TOOL_id: nextId() + '1',
                                    title: '',
                                    link_display_text: '',
                                    link: '',
                                    instructions: ''
                                }
                            ]
                        };
                    }
                    break;
                }
                case 'change': {
                    formData = {
                        ...formData,
                        Tools: [
                            ...formData.Tools.slice(0, +type.target.id),
                            {
                                ...formData.Tools[+type.target.id],
                                [type.target.name]: type.target.value
                            },
                            ...formData.Tools.slice(+type.target.id + 1)
                        ]
                    };

                    break;
                }
                default: {
                    let temp = { ...formData };
                    temp.Tools.splice(type, 1);
                    formData = { ...temp };
                    break;
                }
            }
            return formData;
        }
        case NEXTUP: {
            const { type, element, nextFormData } = payload;
            switch (typeof type === 'object' ? type.type : type) {
                case 'add':
                    {
                        // formData = { ...formData, next_up_block: [...formData.next_up_block.map(block => ({ ...block, next_up: [...block.next_up, { welcome_msg: "", next_up: [{ 'nextCourse_id': nextId() + '1', title: "", instruction: "" }] }))] }]

                        formData = {
                            ...formData,
                            next_up_block: [
                                ...formData.next_up_block.map((block) => ({
                                    ...block,
                                    next_up: [
                                        ...block.next_up,
                                        {
                                            nextCourse_id: nextId() + '1',
                                            title: '',
                                            instruction: ''
                                        }
                                    ]
                                }))
                            ]
                        };
                    }
                    break;

                case 'change': {
                    switch (element) {
                        case 'welcome_msg':
                            const updatedFormData = {
                                ...nextFormData,
                                next_up_block: [
                                    {
                                        welcome_msg: type.target.value,
                                        next_up: [...nextFormData?.next_up_block[0]?.next_up]
                                    }
                                ]
                            };
                            formData = { ...updatedFormData };
                            break;

                        default:
                            formData = {
                                ...formData,
                                next_up_block: [
                                    ...formData.next_up_block.map((block) => {
                                        return {
                                            ...block,
                                            next_up: [
                                                ...block.next_up?.slice(0, +type.target.id),
                                                {
                                                    ...block.next_up[+type.target.id],
                                                    [type.target.name]: type.target.value
                                                },
                                                ...block.next_up?.slice(+type.target.id + 1)
                                            ]
                                        };
                                    })
                                ]
                            };
                            // formData = {
                            //     ...formData,
                            //     next_up_block: [...formData.next_up_block?.slice(0, +type.target.id),
                            //     {
                            //         ...formData.next_up_block[+type.target.id],
                            //         [type.target.name]: type.target.value
                            //     },
                            //     ...formData.next_up_block?.slice(+type.target.id + 1)]
                            // };
                            break;
                    }
                    break;
                }
                default: {
                    let temp = { ...formData };
                    const temp_next_up = temp.next_up_block.map((block) => {
                        const prev_next_up = [...block.next_up];
                        prev_next_up.splice(type, 1);
                        return { ...block, next_up: prev_next_up };
                    });
                    // temp.next_up_block?.splice(type, 1);
                    console.log('temp_next_up', temp_next_up);
                    formData = { ...temp, next_up_block: temp_next_up };
                    break;
                }
            }
            return formData;
        }

        case ADD_START_DATE: {
            const { data, type, index } = payload;
            switch (type) {
                case 'add':
                    {
                        if (formData?.hasOwnProperty('start_date')) {
                            const temp = [formData?.start_date?.concat(data)]
                            let uniqueChars = [...new Set(temp[0])];
                            formData = { ...formData, start_date: uniqueChars }
                        } else {
                            formData = { ...formData, start_date: [] }
                        }

                    }
                    break;
                case 'remove': {
                    const temp = formData.start_date?.filter((item, i) => {
                        return i !== index
                    })
                    formData = { ...formData, start_date: temp }
                }
                case 'select': {
                    formData = { ...formData, start_date_type: data }
                }
                default: {
                    let temp = { ...formData };
                    formData = { ...temp };
                    break;
                }
            }
            return formData;
        }

        // case SELECT_DATE_TYPE: {
        //     const { data, type, index } = payload;
        //     switch (type) {
        //         case 'select':
        //             {
        //                 formData = {
        //                     ...formData,
        //                     start_date_type: data
        //                 };
        //             }
        //          break;
        //         default: {
        //             let temp = { ...formData };
        //             formData = { ...temp };
        //             break;
        //         }
        //     }
        //     return formData;
        // }

        case CRUD_2: {
            const { e, id, sub_id, index, url } = payload;
            let newsubTopic = formData.outline[+id]['sub_topic'][+sub_id];
            switch (e.target.name) {
                case 'remove': {
                    let delIndex = newsubTopic.activity.findIndex(
                        (data) => data.type === e.target.value
                    );
                    newsubTopic.activity.splice(delIndex, 1);
                    break;
                }
                case 'type': {
                    /*if (newsubTopic.activity?.[index]?.type === "group" && e.target.value === "link") {
                                  newsubTopic.activity[index] = !newsubTopic?.activity?.[index]?.attachments ? { ...newsubTopic.activity[index], attachments: [] } : newsubTopic.activity[index];
                                  newsubTopic.activity[index] = { ...newsubTopic.activity[index], attachments: [...newsubTopic.activity[index].attachments, { [e.target.name]: e.target.value, link: '' }] };
                                  newsubTopic.activity.push({ [e.target.name]: e.target.value, link: '' });
                              } else if (e.target.value === 'group') {
                                  newsubTopic.activity[index] = { [e.target.name]: e.target.value, link: '', attachments: [] };
                              } else {
                                  newsubTopic.activity = [];
                                  newsubTopic.activity.push({ [e.target.name]: e.target.value, link: '' });
                              }*/
                    /*newsubTopic.activity[index] = { [e.target.name]: e.target.value, link: '' };*/
                    newsubTopic.activity.push({
                        [e.target.name]: e.target.value,
                        link: ''
                    });
                    break;
                }
                case 'link': {
                    /*if (newsubTopic.activity?.[0]?.type === "group" && e.target.name === "link") {
                                  let newIndex = newsubTopic.activity[0].attachments.findIndex(data => data.type === "link");
                                  newsubTopic.activity[0].attachments[newIndex] = { ...newsubTopic.activity[0].attachments[newIndex], [e.target.name]: e.target.value.trimLeft() };
                                  newsubTopic.activity[index] = { ...newsubTopic.activity[index], [e.target.name]: e.target.value.trimLeft() };
                              } else {
                                  newsubTopic.activity[index] = { ...newsubTopic.activity[index], [e.target.name]: e.target.value.trimLeft() };
                              }*/
                    newsubTopic.activity[index] = {
                        ...newsubTopic.activity[index],
                        [e.target.name]: e.target.value.trimLeft()
                    };
                    break;
                }
                case 'file': {
                    /*if (newsubTopic.activity?.[0]?.type === "group" && e.target.customType === "upload_file") {
                                  newsubTopic.activity[index] = !newsubTopic?.activity?.[index]?.attachments ? { ...newsubTopic.activity[index], attachments: [] } : newsubTopic.activity[index];
                                  let newIndex = newsubTopic.activity[0].attachments.findIndex(data => data.type === "upload_file");
                                  if (newIndex > -1) {
                                      newsubTopic.activity[0].attachments[newIndex] = { "type": e.target.customType, [e.target.type]: url.trimLeft() };
                                      let delIndex = newsubTopic.activity.findIndex(data => data.type === "upload_file");
                                      newsubTopic.activity.splice(delIndex, 1);
                                      newsubTopic.activity.push({ ...newsubTopic.activity[index], "type": e.target.customType, [e.target.type]: url.trimLeft() });
                                  } else {
                                      newsubTopic.activity[0].attachments = [...newsubTopic.activity[index].attachments, { "type": e.target.customType, [e.target.type]: url.trimLeft() }];
                                      newsubTopic.activity.push({ ...newsubTopic.activity[index], "type": e.target.customType, [e.target.type]: url.trimLeft() });
                                  }
                              } else {
                                  newsubTopic.activity = [];
                                  newsubTopic.activity.push({ "type": e.target.customType, [e.target.type]: url.trimLeft() });
                              }*/
                    newsubTopic.activity.push({
                        type: e.target.customType,
                        [e.target.type]: url.trimLeft()
                    });
                    break;
                }
                default: {
                    let newData = formData.outline[id].sub_topic;
                    newData[sub_id] = {
                        ...newData[sub_id],
                        [e.target.name]: e.target.value.trimLeft()
                    };
                    return {
                        ...formData,
                        outline: [
                            ...formData.outline.slice(0, +id),
                            {
                                ...formData.outline[+id],
                                sub_topic: newData
                            },
                            ...formData.outline.slice(+id + 1)
                        ]
                    };
                }
            }
            return {
                ...formData,
                outline: [
                    ...formData.outline.slice(0, +id),
                    {
                        ...formData.outline[+id],
                        sub_topic: [
                            ...formData.outline[+id]['sub_topic'].slice(0, +sub_id),
                            newsubTopic,
                            ...formData.outline[+id]['sub_topic'].slice(+sub_id + 1)
                        ]
                    },
                    ...formData.outline.slice(+id + 1)
                ]
            };
        }
        case OVERVIEW: {
            const { type } = payload;
            switch (typeof type === 'object' ? type.type || type.target.type : type) {
                case 'add': {
                    formData = {
                        ...formData,
                        overview: [
                            ...formData.overview,
                            { overview: "", title: "",'Overview_ID': nextId() }
                        ]
                    };
                    break;
                }
                case 'change': {
                    const targetName = type.target.name;
                    const targetValue = type.target.value?.trimLeft()
                    const wordCount = targetValue.trim().split(/\s+/).length
                   
                    formData = {
                        ...formData,
                        overview: formData.overview.map((overview, index) =>
                            index === +type.target.id
                                ? { ...overview, [targetName]: targetName === "event_description" && wordCount > 500 ? targetValue
                                .trim()
                                .split(/\s+/)
                                .slice(0, 500)
                                .join(' ') : targetValue }
                                : overview
                        )
                    };
                    break;
                }
                case 'deleteevent': {
                    const { type } = payload;
                    const targetName = type.target.name;
                   
                    formData = {
                        ...formData,
                        overview: formData.overview.map((overview, index) =>
                            index ===  type.target.id
                                ? { ...overview, [targetName]: '' }
                                : overview
                        )
                    };
                    break;
                }
                default: {
                    let temp = { ...formData };
                    temp.overview.splice(type, 1);
                    formData = { ...temp };
                    break;
                }
            }
            return formData;
        }
        case CRUD_1: {
            const { e, data } = payload;
            switch (e?.target?.type || Object.keys(e)[0] || e.target.name) {
                case 'checkbox': {
                    formData = { ...formData, [e.target.name]: e.target.checked };
                    break;
                }
                case 'file': {
                    formData = { ...formData, ...payload.data };
                    break;
                }
                case 'removeFile': {
                    formData = { ...formData, ...payload.data };
                    break;
                }
                case 'course_type': {
                    formData = { ...formData, course_type: e.target.value };
                    break;
                }
                default: {
                    if (data) {
                        if (e.target.name === "course_type") {
                            formData = {
                                ...formData,
                                course_type: e.target.value
                            };
                        } else {
                            const keys = data?.map((item) => item?.key);
                            if (e.target.name === 'category_name')
                                formData = {
                                    ...formData,
                                    category_id: keys,
                                    [e.target.name]: e.target.value
                                };
                            else
                                formData = {
                                    ...formData,
                                    [e.target.name]: e.target.value?.trimLeft(),
                                    category_id: data.key
                                };
                        }
                    }
                    else {
                        formData = {
                            ...formData,
                            [e.target.name]:
                                typeof e.target.value === 'string'
                                    ? e.target.value?.trimLeft()
                                    : e.target.value
                        };
                    }
                    break;
                }
            }
            return formData;
        }
            case FOURCEUPD: {
            const { type } = payload;
                formData = { ...formData, show_outline_button:type.target.checked };
            return formData;
        }
        default: {
            return formData;
        }
    }
};
